/**
 * Custom Cipher implementation
 * Allows users to define their own character mappings
 */

export const customEncrypt = (text, mapping = {}) => {
  if (Object.keys(mapping).length === 0) {
    // Default simple substitution if no mapping provided
    const defaultMapping = 'zyxwvutsrqponmlkjihgfedcbaZYXWVUTSRQPONMLKJIHGFEDCBA';
    const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    
    const map = {};
    for (let i = 0; i < alphabet.length; i++) {
      map[alphabet[i]] = defaultMapping[i];
    }
    mapping = map;
  }
  
  return text.split('').map(char => mapping[char] || char).join('');
};

export const customDecrypt = (text, mapping = {}) => {
  if (Object.keys(mapping).length === 0) {
    // Default reverse mapping
    const defaultMapping = 'zyxwvutsrqponmlkjihgfedcbaZYXWVUTSRQPONMLKJIHGFEDCBA';
    const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    
    const reverseMap = {};
    for (let i = 0; i < alphabet.length; i++) {
      reverseMap[defaultMapping[i]] = alphabet[i];
    }
    mapping = reverseMap;
  } else {
    // Reverse the provided mapping
    const reverseMap = {};
    Object.entries(mapping).forEach(([key, value]) => {
      reverseMap[value] = key;
    });
    mapping = reverseMap;
  }
  
  return text.split('').map(char => mapping[char] || char).join('');
};

export const customCipher = {
  name: 'Custom Cipher',
  encrypt: customEncrypt,
  decrypt: customDecrypt,
  requiresKey: true,
  keyLabel: 'Character Mapping (JSON)',
  keyType: 'textarea',
  defaultKey: '{}',
  description: 'Custom character substitution cipher'
};
